import { State } from '@/types'
import { Store } from 'vuex'
import { createVerifyResult, applyValidationResults, validateField } from './utils'

export default async function validateReviewEditorialView(store: Store<State>) {
  const verifyResult = createVerifyResult('ReviewerInfo')

  const validationResults = await Promise.all([
    validateField(store.state.activeSubmission.reviewers, 'at-least-two-recommended-reviewers-required'),
    validateField(store.state.activeSubmission.transparentPeerReview, 'transparent-peer-review-option-required'),
    validateField(store.state.activeSubmission.editorialOfficeIds, 'at-least-two-associate-editors-required'),
  ])

  applyValidationResults(validationResults, verifyResult)

  verifyResult.valid = verifyResult.errors.length === 0

  store.commit('setVerifyResult', {
    key: 'reviewEditorialVerifyResult',
    verifyResult,
  })
}
